module.exports = __webpack_public_path__ + "static/media/horizontal.3c10d06c.png";